import React from "react";
import { cx, payoutUi } from "./payoutDesignSystem";

type PayoutButtonVariant = "primary" | "secondary" | "subtle" | "danger";

type PayoutButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: PayoutButtonVariant;
  icon?: React.ReactNode;
};

function PayoutButton({
  variant = "secondary",
  icon,
  className,
  children,
  ...props
}: PayoutButtonProps) {
  return (
    <button
      type="button"
      {...props}
      className={cx(payoutUi.button.base, payoutUi.button[variant], className)}
    >
      {icon}
      {children}
    </button>
  );
}

export default PayoutButton;
